
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shipper/flatbed-messenger",
      function () {
        return require("private-next-pages/shipper/flatbed-messenger.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shipper/flatbed-messenger"])
      });
    }
  